import { Injectable, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { GridOptions, GridReadyEvent  } from 'ag-grid-community';
import { UserLocalStoreService } from '../services/user-local-store.service';

export interface GridState {
  page: any,
  columnState: any,
}

@Injectable()
export class AgGridService {

  static getOptions(): GridOptions {
    return {
      rowModelType: 'clientSide',
      domLayout: 'autoHeight',
      rowHeight: 42,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
      },
      getRowStyle: (params) => params.node && params.node.rowIndex !== null && params.node.rowIndex % 2 === 0 ? { background: '#f9f9f9' } : undefined
    };
  }

  static setting(event: GridReadyEvent) {
    event.api.sizeColumnsToFit();
  }

  static saveGridState(event: GridReadyEvent, gridRestored: boolean, _userLocalStorage: UserLocalStoreService, key: string) {
    if (gridRestored) {
      const state: GridState = {
        page: event.api.paginationGetCurrentPage(),
        columnState: event.api.getColumnState(),
      };
      _userLocalStorage.save(key, state);
    }
  }

  static restoreGridState(event: GridReadyEvent, _userLocalStorage: UserLocalStoreService, key: string) {
    const saved = _userLocalStorage.get<GridState>(key);
    if (saved) {
      event.api.applyColumnState({
        state: saved.columnState,
        applyOrder: true
      });
      event.api.paginationGoToPage(saved.page);
    }
    return true;
  }

  // static restoreGridToDefaultState(event: GridReadyEvent, _userLocalStorage: UserLocalStoreService, key: string) {
  //   event.api.setFilterModel(null);
  //   event.api.applyColumnState({
  //     defaultState:{
  //       sort: null
  //     }
  //   })
  //   event.api.paginationGoToFirstPage(),
  //   event.api.refreshCells({force: true})
  //     const state: GridState = {
  //       page: event.api.paginationGetCurrentPage(),
  //       columnState: event.api.getColumnState(),
  //     };
  //     _userLocalStorage.save(key, state)
  // }

  static editButton(renderer: Renderer2, _router: Router, edit: (router: Router, data: any) => void, data: any) {
    const button = renderer.createElement('button');
    renderer.addClass(button, 'btn');
    renderer.addClass(button, 'btn-link');
    renderer.addClass(button, 'btn-sm');
    renderer.setAttribute(button, 'title', 'Edit');
    const icon = renderer.createElement('i');
    renderer.addClass(icon, 'fa');
    renderer.addClass(icon, 'fa-pencil');
    renderer.appendChild(button, icon);
    renderer.listen(button, 'click', () => edit(_router, data));
    return button;
  }

  static iconButton(renderer: Renderer2, _router: Router, edit: (router: Router, data: any) => void, data: any, iconClass: string) {
    const button = renderer.createElement('button');
    renderer.addClass(button, 'btn');
    renderer.addClass(button, 'btn-link');
    renderer.addClass(button, 'btn-sm');
    renderer.setAttribute(button, 'title', 'Edit');
    const icon = renderer.createElement('i');
    renderer.addClass(icon, 'fa');
    renderer.addClass(icon, iconClass);
    renderer.appendChild(button, icon);
    renderer.listen(button, 'click', () => edit(_router, data));
    return button;
  }

  static deleteButton(renderer: Renderer2, service: any, actionFunction: (service: any, data: any) => void, data: any) {
    const button = renderer.createElement('button');
    renderer.addClass(button, 'btn');
    renderer.addClass(button, 'btn-link');
    renderer.setAttribute(button, 'title', 'Delete');
    const icon = renderer.createElement('i');
    renderer.addClass(icon, 'fa');
    renderer.addClass(icon, 'fa-trash-o');
    renderer.appendChild(button, icon);
    renderer.listen(button, 'click', () => actionFunction(service, data));
    return button;
  }

  static checkBox(renderer: Renderer2, service: any, actionFunction: (service: any, data: any) => void, data: any, checked: boolean) {
    const checkbox = renderer.createElement('input');
    renderer.setAttribute(checkbox, 'type', 'checkbox');
    renderer.setAttribute(checkbox, 'id', 'confirm');
    renderer.setAttribute(checkbox, 'name', 'confirm');
    renderer.addClass(checkbox, 'btn-link');
    renderer.setProperty(checkbox, 'checked', checked);
    renderer.listen(checkbox, 'click', () => actionFunction(service, data));
    return checkbox;
  }

  static downloadButton(
    renderer: Renderer2,
    downloadFile: () => void,
  ) {
    const button = renderer.createElement('button');
    renderer.addClass(button, 'btn');
    renderer.addClass(button, 'btn-link');
    renderer.addClass(button, 'btn-sm');
    renderer.setAttribute(button, 'title', 'Download');

    const icon = renderer.createElement('i');
    renderer.addClass(icon, 'fa');
    renderer.addClass(icon, 'fa-download');
    renderer.appendChild(button, icon);

    renderer.listen(button, 'click', () => downloadFile());
    return button;
  }

  static editButtonWithText(
    renderer: Renderer2,
    _router: Router,
    edit: (router: Router, data: any) => void,
    data: any,
    text?: string,
  ) {
    const container = renderer.createElement('a');
    renderer.addClass(container, 'btn');
    renderer.addClass(container, 'btn-link');
    renderer.addClass(container, 'text-decoration-none');
    renderer.setAttribute(container, 'title', 'Edit');
    const span = renderer.createElement('span');
    renderer.appendChild(span, renderer.createText(text!));
    renderer.appendChild(container, span);
    renderer.listen(container, 'click', () => edit(_router, data));
    return container;
  }
}
